<template>
  <popup @codd_close="closePopup">
    <span class="close" @click="closePopup"> &times;</span>
    <div class="popup-content" v-if="!success">
      <p> {{ $t('powerpack.imageContainer.popupShare.shareText') }}</p>
        <InputLabel :label="$t('powerpack.imageContainer.popupShare.emailAddress')" class="pl-0"></InputLabel>
        <input
            name="share-email"
            type="text"
            v-model="email"
            class="form-control"
        />

      <div>
        <label for="optIn">
          <input type="checkbox" :value="true" v-model="optIn" id="optIn" />
          {{ $t('powerpack.imageContainer.popupShare.optIn') }}
        </label>
      </div>

      <div class="alert alert-danger" v-if="error">
        {{ error }}
      </div>


      <button
        class="btn btn-primary"
        @click="sendTrigger"
        :disabled="busy"
      >{{ $t('powerpack.imageContainer.popupShare.send') }}</button>

    </div>
    <div class="popup-content" v-else-if="success">
      {{ $t('powerpack.imageContainer.popupShare.success') }}
    </div>
  </popup>
</template>

<script>
import Popup from "@/components/popup/Popup";
import InputLabel from "@/components/input/Label";
import axios from "axios";

export default {
  name: "PopupTriggerShare",
  components: {Popup, InputLabel},
  data() {
    return {
      email: '',
      error: null,
      success: false,
      optIn: false,
      busy: false,
    }
  },
  methods: {
    closePopup() {
      this.$store.commit('share/setOpen', false);
    },
    sendTrigger() {
      this.error = null;
      this.busy = true;

      if (!this.email) {
        this.error = this.$t('powerpack.imageContainer.popupShare.errors.emailRequired');
        this.busy = false;
        return;
      }

      if (!this.validateEmail(this.email)) {
        this.error = this.$t('powerpack.imageContainer.popupShare.errors.emailInvalid');
        this.busy = false;
        return;
      }

      return axios.post(
          'mail-event/trigger',
          {
            "email": this.email,
            "trigger_type": this.trigger,
            "configurator_type": this.configurator,
            "locale": this.locale,
            "uid": this.uid,
            "opt_in": this.optIn,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.locale,
            },
          }
      )
          .then(({ data }) => {
            this.success = true;
          })
          .catch(({response}) => {
            this.error = response.data.message;
          }).finally(() => {
            this.busy = false;
          });
    },
    validateEmail: (email) => {
      return String(email)
          .toLowerCase()
          .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    },
  },
  computed: {
    configurator() {
      return this.$store.state.share.configurator;
    },
    uid() {
      return this.$store.state.share.uid;
    },
    locale() {
      return this.$store.state.share.locale;
    },
    trigger() {
      return this.$store.state.share.trigger;
    },
  }
};
</script>
<style lang="scss" scoped>
.close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.popup-content {
  padding: 20px;

  input[type=text].form-control {
    border-radius: 20px;
    margin: .5rem 0 1rem;
    max-width: 300px;
  }
}
</style>